import { OperationType, ROUTE_PATH } from "common/constants/sm-constants";

export class cardStatsMetaModel {
    cardName: string = '';
    cardCount: number = null;
    cardRedirection: ROUTE_PATH = null;
    operationType: OperationType = OperationType.VIEW;
    transferParam: any = null

    constructor(private propCardName: string, private propCardCount: number, private propCardRedirection: ROUTE_PATH, private propoperationType: OperationType = null, private propTransferParam: any = null){
        this.generateProperties()
    }

    generateProperties() {
        this.cardName = this.propCardName;
        this.cardCount = this.propCardCount;
        this.cardRedirection = this.propCardRedirection;
        this.operationType = this.propoperationType;
        this.transferParam = this.propTransferParam;
    }
}